import React from 'react';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import type { AnimationEvent } from 'Components/widgets/event-animation/EventAnimation';
import { EventAnimation } from 'Components/widgets/event-animation/EventAnimation';
export type LineProps = {
  title: string;
  items: Array<AnimationEvent>;
};
export const EventAnimationLine = ({ items, title }: LineProps) => (
  <SiteContainer className="Line" data-testid="Line-EventAnimation">
    <LineTitle>{title}</LineTitle>
    <EventAnimation events={items} />
  </SiteContainer>
);
